"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllPointsForStudent = getAllPointsForStudent;
exports.getBasicPointsForStudent = getBasicPointsForStudent;
exports.getConnectedStudents = getConnectedStudents;
exports.getStudent = getStudent;
exports.getStudentName = getStudentName;
exports.getStudents = getStudents;
exports.getTeamsFromMission = getTeamsFromMission;
var _analytics = require("../analytics");
var _functions = require("../utility/functions");
/**
 * Gets the raw amount of points that a student earned on a mission by themselves
 * @param {?SharedMissionStateSelectorState} missionState
 * @param {string}
 * @returns {number}
 */
function getBasicPointsForStudent(missionState, studentId) {
  if (!missionState?.points.studentPoints[studentId]) return 0;
  return (0, _analytics.sumPointsObject)(missionState.points.studentPoints[studentId]);
}

/**
 * Gets the total amount of points that a student earned on a mission: individual points + crew points
 * @param {?SharedMissionStateSelectorState} missionState
 * @param {string}
 * @returns {number}
 */
function getAllPointsForStudent(missionState, studentId) {
  return missionState ? getBasicPointsForStudent(missionState, studentId) + (0, _analytics.sumPointsObject)(missionState.points.crewPoints) : 0;
}

/**
 * Gets a students name given their student id.
 * @param {?BothFullMissionStates} missionState
 * @param {string}
 * @returns {string}
 */
function getStudentName(missionState, studentId) {
  let student = getStudent(missionState, studentId);
  if (!student) {
    return '';
  }
  const studentName = student.lastName ? student.firstName + ' ' + student.lastName : student.firstName;
  return studentName;
}

/**
 * Gets all students on a mission
 * @param {?BothFullMissionStates} missionState
 * @param {?boolean} includeOwners - if false or undefined, will exclude the students which represent the mission owners (teachers/flight-directors)
 * @returns {{[string]: StudentWithPoints}}
 */
function getStudents(missionState, includeOwners = false) {
  if (!missionState) {
    return {};
  }
  const students = {};
  Object.keys(missionState.students).forEach(studentId => {
    const student = missionState.students[studentId];
    if (!includeOwners && student.isOwner) {
      return;
    }
    students[studentId] = {
      ...student,
      points: getAllPointsForStudent(missionState, student.id)
    };
  });
  return students;
}

/**
 * Gets a single student from a mission with their student point value as well
 * @param {?BothFullMissionStates} missionState
 * @param {string}
 * @returns {?StudentWithPoints}
 */
function getStudent(missionState, studentId) {
  if (!missionState || !missionState.students[studentId]) return null;
  const student = missionState.students[studentId];
  return {
    ...student,
    points: getAllPointsForStudent(missionState, student.id)
  };
}

/**
 * Gets connected students from a mission.
 * @param {?BothFullMissionStates} state
 * @param {?boolean} includeOwners - if false or undefined, will exclude the students which represent the mission owners (teachers/flight-directors)
 * @return {{[string]:StudentWithPoints}} Id map of studentIds to their student object
 */
function getConnectedStudents(missionState, includeOwners = false) {
  return (0, _functions.reduceObject)(getStudents(missionState, includeOwners), (result, current) => {
    if (current.connected) {
      result[current.id] = current;
    }
    return result;
  }, {});
}

/**
 * Returns teams in alphabetical order with all students listed on each team (not just studentIds) from a
 * standard mission
 * @param { ?JuniorPlusMissionFullState} missionState
 * @returns {?(DisplayTeam[])}
 */
function getTeamsFromMission(missionState) {
  if (!missionState) return;
  const students = missionState.students;
  if (missionState.teams) {
    return (0, _functions.values)(missionState.teams).sort((a, b) => {
      if (a.displayName > b.displayName) {
        return 1;
      }
      if (a.displayName < b.displayName) {
        return -1;
      }
      return 0;
    }).map(team => ({
      ...team,
      lead: team.lead ? students[team.lead] : null,
      students: team.students.map(studentId => students[studentId])
    }));
  }
}